'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validators = require('constructicon/lib/validators');

var validators = _interopRequireWildcard(_validators);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = function (_ref) {
  var post = _ref.post;
  return {
    fields: {
      message: {
        label: 'Post an update',
        type: 'contenteditable',
        validators: [function (val, _ref2) {
          var image = _ref2.image,
              video = _ref2.video;

          if (!image && !video) {
            return validators.required('Please include a message or an image or video.')(val);
          }
        }]
      },
      image: {
        label: 'Attach an image'
      },
      video: {
        type: 'search',
        label: 'Enter a video URL (e.g. Youtube, Facebook, Vimeo)',
        placeholder: 'e.g. https://www.youtube.com/watch?v=yPw4GHqFV6U',
        autoFocus: true
      }
    }
  };
};